import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DatePicker from '../DatePicker';
import { noop } from '../propTypes';

function MultiDatePicker({ onDatesSelected }) {
    const [selectedStartDate, setSelectedStartDate] = useState('');
    const [selectedEndDate, setSelectedEndDate] = useState('');

    useEffect(() => {
        if (selectedStartDate && selectedEndDate) {
            onDatesSelected({
                startDate: selectedStartDate,
                endDate: selectedEndDate,
            });
        }
    }, [selectedStartDate, selectedEndDate]);

    const handleDateChange = (date, id) => {
        if (id === 'end') {
            setSelectedEndDate(date ? new Date(date).toISOString() : '');
        } else {
            setSelectedStartDate(date ? new Date(date).toISOString() : '');
            if (!date) {
                setSelectedEndDate('');
            }
        }
    };

    return (
        <div className="row">
            <div className="col-6">
                <DatePicker
                    title="Start Date"
                    bootstrapIcon="icon-calendar-empty"
                    handleDateChange={(date) => {
                        handleDateChange(date, 'start');
                    }}
                    pickerProps={{
                        maxDate: selectedEndDate,
                    }}
                />
            </div>
            <div className="col-6">
                <DatePicker
                    title="End Date"
                    bootstrapIcon="icon-calendar-empty"
                    handleDateChange={(date) => {
                        handleDateChange(date, 'end');
                    }}
                    pickerProps={{
                        disabled: !selectedStartDate,
                        minDate: selectedStartDate,
                    }}
                />
            </div>
        </div>
    );
}

MultiDatePicker.propTypes = {
    onDatesSelected: PropTypes.func,
};

MultiDatePicker.defaultProps = {
    onDatesSelected: noop,
};

export default MultiDatePicker;
